export type ConversationStatus =
  | 'awaiting-input'
  | 'working'
  | 'complete'
  | 'paused'
  | 'idle'
  | 'not-started';

interface Props {
  status: ConversationStatus;
}

const MAP: Record<ConversationStatus, { bg: string; fg: string; label: string }> = {
  'awaiting-input': { bg: 'var(--accent-bg)', fg: 'var(--accent)', label: 'Awaiting input' },
  'working': { bg: '#e6f0fb', fg: '#1f6feb', label: 'Working' },
  'complete': { bg: '#e6f4ec', fg: '#2f855a', label: 'Complete' },
  'paused': { bg: 'var(--bg-alt2)', fg: '#8a6d3b', label: 'Paused' },
  'idle': { bg: 'var(--bg-inset)', fg: 'var(--text-soft)', label: 'Idle' },
  'not-started': { bg: 'var(--bg-inset)', fg: 'var(--text-soft)', label: 'Not started' },
};

export function StatusPill({ status }: Props) {
  const m = MAP[status] ?? MAP.idle;
  return (
    <span
      style={{
        background: m.bg,
        color: m.fg,
        padding: '2px 8px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: 0.1,
        whiteSpace: 'nowrap',
      }}
    >
      {m.label}
    </span>
  );
}
